import { render, staticRenderFns } from "./ButtonsExperience.vue?vue&type=template&id=89e6d278&scoped=true"
import script from "./ButtonsExperience.vue?vue&type=script&lang=js"
export * from "./ButtonsExperience.vue?vue&type=script&lang=js"
import style0 from "./ButtonsExperience.vue?vue&type=style&index=0&id=89e6d278&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e6d278",
  null
  
)

export default component.exports